import { useContext } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { AppCenterPopup, CenterPopupHeader, CenterPopupHeaderD3 } from "src/component"
import PopupLockIcon from 'src/assets/svg/forgot-password-lock'
import { Design } from 'src/model'

export const Identification: React.FC<any> = ({formData, handleInput, next, close}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        next()
    }

    return (
        <AppCenterPopup height='32.2' zIndex='8' close={close}>
            <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
            {/* { institutionData.design != Design.DESIGN_3 ?
                <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} close={close} />
                :<CenterPopupHeaderD3 title='One Time Password' close={close} />
            } */}
            <CustomContainer height="21.2" className='popup-content-container'>
                <CustomContainer topMargin="1.5">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Forgot Your Password?</ScreenTitle>
                    <Form onSubmit={handleProceed} topMargin='2'>
                        <FormGroup>
                            <label>Enter Username</label>
                            <input 
                                name='username'
                                placeholder="Username"
                                value={formData.username}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                        >
                            Next
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}